// this file is generated from the root of the admin repo
// see https://github.com/tocktix/admin/wiki/Svg-Icons-Components in order to add a new file;
import * as React from 'react';
import SvgIcon, { SvgIconProps } from '@material-ui/core/SvgIcon';

/**
 * @deprecated use "@tock/icons" import instead
 * This new package will be where all Icons are imported from going forward
 * You can still use these icons in <IconMigrationUtil /> as the legacy icon
 */
export const SvgIconAdd = (props: SvgIconProps) =>
  React.createElement(
    SvgIcon,
    { width: '1em', height: '1em', viewBox: '0 0 24 24', fill: 'none', ...props },
    <path
      d="M24 12c0 .41-.34.75-.75.75h-10.5v10.5c0 .41-.34.75-.75.75s-.75-.34-.75-.75v-10.5H.75c-.41 0-.75-.34-.75-.75s.34-.75.75-.75h10.5V.75c0-.41.34-.75.75-.75s.75.34.75.75v10.5h10.5c.42 0 .75.34.75.75z"
      fill="currentColor"
    />
  );
export default SvgIconAdd;
